import { Action } from '@ngrx/store';
import { IOrder } from '../models/order.model';
// import { IReservation } from 'src/app/admin-pages/reservations/reservations.model';

export const SET_ORDER = '[Order] Set Order';
export const UNSET_ORDER = '[Order] Unset Order';


export class SetOrderActions implements Action {
    readonly type = SET_ORDER;

    constructor(public order: IOrder) { }
}

export class UnsetOrdertAction implements Action {
    readonly type = UNSET_ORDER;
}

export type acciones = SetOrderActions | UnsetOrdertAction;